import React, { Ref } from 'react';

import './Banner.scss';

interface BannerItem {
  target: string;
  name: string;
  images: {
    url: string;
    width: number;
  }[];
}

interface BannerProps {
  config: {
    baseUrl: string;
    items: BannerItem[];
    switchTime: number;
    animateInterval: number;
    animateStep: number;
  };
  showRows: boolean;
  showDots: boolean;
}

interface BannerState {
  maxCount: number;
  currentIndex: number;
  scrollPosition: number;
  currentWidth: number;
  mouseOver: boolean;
}

export default class Banner extends React.Component<BannerProps, BannerState> {
  switchTimer?: NodeJS.Timer;
  scrollTimer?: NodeJS.Timer;
  mouseLeaveTimer: NodeJS.Timer;
  sliderRef: Ref<HTMLDivElement>;

  constructor(props) {
    super(props);

    let maxCount = 2;

    if (
      this.props.config?.items != undefined &&
      this.props.config.items.length < 2
    ) {
      maxCount = this.props.config.items.length;
    }

    let currentWidth = 1600;

    this.state = {
      maxCount: maxCount,
      currentIndex: 0,
      scrollPosition: 0,
      currentWidth: currentWidth,
      mouseOver: false,
    };

    this.sliderRef = React.createRef();
  }

  startDrag(e) {
    this.stopAnimate();
    let margines = 45;

    let sliderRef: any = this.sliderRef;
    if (sliderRef.current != undefined) {
      let rect = sliderRef.current.parentElement.getBoundingClientRect();

      let lPos = e.clientX - rect.left;
      let rPos = rect.right - e.clientX;
      if (!(lPos < margines || rPos < margines)) {
        document.slider = sliderRef.current;
        document.sliderPosition = this.state.currentIndex;
        document.sliderRef = this;
        if (e.type == 'mousedown') {
          document.startX = e.clientX;
          document.onmousemove = this.moveHandler;
          document.onmouseup = this.endDrag;
          document.onmouseleave = this.endDrag;
        } else {
          document.startX = e.targetTouches[0].screenX;
          document.ontouchmove = this.moveHandler;
          document.ontouchend = this.endDrag;
        }
        //document.ontouchend = this.endDrag;
      }
    }
  }

  moveHandler(e) {
    let xDelta = 0;
    if (e.type == 'touchmove')
      xDelta = e.targetTouches[0].screenX - document.startX;
    else xDelta = e.clientX - document.startX;

    let slider: any = document.slider;
    if (slider != undefined && slider.parentElement != undefined) {
      let width = slider.parentElement.offsetWidth;
      let currentIndex = document.sliderPosition;

      let newPosition = (width * currentIndex - xDelta) * -1;

      slider.style.transform = 'translateX(' + newPosition + 'px)';
    }
  }

  endDrag(e) {
    let xDelta = 0;
    if (e.type == 'touchend')
      xDelta = e.changedTouches[0].screenX - document.startX;
    else xDelta = e.clientX - document.startX;

    let sliderRef = document.sliderRef;
    if (xDelta > 50 || xDelta < -50) sliderRef.setBanner(xDelta < 0);
    else if (xDelta < 8 && xDelta > -8) {
      //click
      let currentIndex = sliderRef.state.currentIndex;
      let link = sliderRef.props.config?.items?.[currentIndex]?.target;

      if (link != null) window.location.href = link;
    }

    delete document.startX;
    delete document.slider;
    delete document.sliderPosition;
    delete document.sliderRef;

    if (e.type == 'touchmove') {
      document.ontouchmove = null;
      document.ontouchend = null;
    } else {
      document.onmousemove = null;
      document.onmouseup = null;
      document.onmouseleave = null;
    }
    if (sliderRef != undefined) sliderRef.startAnimate();
  }

  stopAnimate() {
    if (this.mouseLeaveTimer != undefined) {
      clearTimeout(this.mouseLeaveTimer);
      this.mouseLeaveTimer = undefined;
    }

    this.stopSwitchTimer();
    this.stopScroolTimer();
    this.setState({ scrollPosition: 0, mouseOver: true });
    let currentXPosition = this.state.currentIndex * 100;

    let sliderRef: any = this.sliderRef;

    if (sliderRef.current != null) {
      sliderRef.current.style.transform =
        'translateX(-' + currentXPosition + '%)';
    }
  }

  startAnimate() {
    if (this.mouseLeaveTimer != undefined) {
      clearTimeout(this.mouseLeaveTimer);
      this.mouseLeaveTimer = undefined;
    }

    this.mouseLeaveTimer = setTimeout(() => {
      this.startScroolTimer();
      this.setState({ mouseOver: false });
    }, 5000);
  }

  render() {
    let maxItem = this.state.maxCount;
    return (
      <div
        id="banner"
        onMouseOver={() => {
          this.stopAnimate();
        }}
        onMouseDown={(e) => {
          this.startDrag(e);
        }}
        onTouchStart={(e) => {
          this.startDrag(e);
        }}
        onMouseLeave={() => {
          this.startAnimate();
        }}
      >
        <div className="bannercarusel">
          <div className="bannerSlider" ref={this.sliderRef}>
            {this.props.config?.items?.length > 0 ? (
              <>
                {this.renderBannerItem(
                  this.props.config.items[this.props.config.items.length - 1],
                  -1,
                )}
                {this.props.config.items.map((item, index) => {
                  if (index < maxItem) {
                    return this.renderBannerItem(item, index);
                  }
                })}
                {this.renderBannerItem(
                  this.props.config.items[0],
                  this.props.config.items.length,
                )}
              </>
            ) : null}
          </div>
        </div>
        {this.state.mouseOver && this.props.showRows ? (
          <div style={{ position: 'relative', height: '100%' }}>
            <button
              className="prev-next-button previous"
              onClick={() => {
                this.setBanner(false);
              }}
            />
            <button
              className="prev-next-button next"
              onClick={() => {
                this.setBanner(true);
              }}
            />
          </div>
        ) : null}
        {this.props.showDots && this.props.config?.items?.length > 0 ? (
          <ol className="dots">
            {this.props.config.items.map((item, index) => {
              let className = 'dot';
              if (index == this.state.currentIndex) className += ' selected';
              return (
                <li
                  key={'carouselDot' + index}
                  data-index={index}
                  className={className}
                  onClick={(e) => {
                    /*
                    if (this.props.clickGuiNotify != null)
                      this.props.clickGuiNotify();
                    let newIndex = +e.target.getAttribute('data-index');
                    this.setNewItemIndex(newIndex);
                    */
                  }}
                ></li>
              );
            })}
          </ol>
        ) : null}
      </div>
    );
  }

  setBanner(next: boolean) {
    let sliderRef: any = this.sliderRef;

    if (
      sliderRef.current != null &&
      this.state.currentWidth != sliderRef.current.clientWidth
    ) {
      this.setState({ currentWidth: sliderRef.current.clientWidth });
    }

    let stateItem: any = {};
    let itemCount = this.props.config?.items?.length ?? 0;

    //Prepare Next Image
    if (itemCount > this.state.maxCount) {
      if (this.state.currentIndex == 0 && !next) {
        stateItem.maxCount = itemCount;
      } else stateItem.maxCount = this.state.maxCount + 1;
    }

    let currentIndex = this.state.currentIndex;

    if (next) {
      currentIndex++;
    } else {
      currentIndex--;
    }

    if (currentIndex < 0) {
      currentIndex = itemCount > 0 ? itemCount - 1 : 0;
    } else if (currentIndex > itemCount - 1) {
      currentIndex = 0;
    }

    let currentXPosition = currentIndex * 100;

    if (sliderRef.current != null)
      sliderRef.current.style.transform =
        'translateX(-' + currentXPosition + '%)';

    stateItem.currentIndex = currentIndex;
    stateItem.scrollPosition = 0;

    this.setState(stateItem);
  }

  renderBannerItem(item: BannerItem, index: number) {
    let bestIndex = 0;
    let currentWidth = this.state.currentWidth;
    let bestDelte = Math.pow(item.images[0].width - currentWidth, 2);

    for (let i = 1; i < item.images.length; i++) {
      let curentDelta = Math.pow(item.images[i].width - currentWidth, 2);
      if (curentDelta < bestDelte) {
        bestIndex = i;
        bestDelte = curentDelta;
      }
    }

    let bestImageUrl = item.images[bestIndex].url;

    return (
      <div
        className="bannerItem"
        style={{
          left: index * 100 + '%',
        }}
        key={'bannerItem' + index}
      >
        <img
          src={'https://www.moluna.de/' + bestImageUrl}
          alt={item.name}
          style={{ maxWidth: '100%' }}
        />
      </div>
    );
  }
  /*
overflow-x: hidden;
    width: 100%;
    overflow-y: hidden;
    position: relative;
*/
  componentDidMount(): void {
    this.startSwitchTimer();

    let sliderRef: any = this.sliderRef;

    if (
      sliderRef.current != null &&
      this.state.currentWidth != sliderRef.current.clientWidth
    ) {
      this.setState({ currentWidth: sliderRef.current.clientWidth });
    }
  }

  startSwitchTimer() {
    let switchTimer = 30000;
    if (this.props.config?.switchTime != undefined)
      switchTimer = this.props.config.switchTime;

    this.stopSwitchTimer();

    this.switchTimer = setTimeout(() => {
      this.switchBanner();
    }, switchTimer);
  }

  stopSwitchTimer() {
    if (this.switchTimer != null) clearTimeout(this.switchTimer);
    this.switchTimer = undefined;
  }

  startScroolTimer() {
    this.stopScroolTimer();

    this.scrollTimer = setInterval(() => {
      this.scrollHandler();
    }, this.props.config.animateInterval);
  }

  stopScroolTimer() {
    if (this.scrollTimer != null) clearInterval(this.scrollTimer);
    this.scrollTimer = undefined;
  }

  componentWillUnmount(): void {
    this.stopSwitchTimer();
    this.stopScroolTimer();
  }

  switchBanner() {
    //Start Scroll
    this.stopSwitchTimer();
    this.startScroolTimer();
  }

  scrollHandler() {
    let newPostion = this.state.scrollPosition + this.props.config.animateStep;

    let currentIndex = this.state.currentIndex;
    let newstate = null;
    if (newPostion < 100) {
      //Part Scroll
      newstate = {
        scrollPosition: newPostion,
      };

      let sliderRef: any = this.sliderRef;
      let currentXPosition = currentIndex * 100 + newPostion;

      if (sliderRef.current != null)
        sliderRef.current.style.transform =
          'translateX(-' + currentXPosition + '%)';

      this.setState(newstate);
    } else {
      //End of Scroll
      newPostion = 0;
      this.setBanner(true);
      this.stopScroolTimer();
      this.startSwitchTimer();
      /*
      //currentIndex = currentIndex + 1;

      if (currentIndex >= this.props.config.items.length) {
        currentIndex = 0;
      }

      

      newstate = {
        scrollPosition: newPostion,
        currentIndex: currentIndex,
      };
      */
    }
  }
}
